module.exports = __webpack_public_path__ + "img/Dantam Hair 27.23c4b1a6.jpg";